import React from "react";

type RadioButtonProps = {
    inputId: string;
    label: string | undefined;
    checked: boolean;
    name: string;
    onSelect: () => void;
    readOnly: boolean;
    containerClassName?: string;
    labelClassName?: string;
    onLabelClick?: () => void;
};

function RadioButton({
    inputId,
    label,
    name,
    checked,
    onSelect,
    onLabelClick,
    containerClassName = "",
    labelClassName = "",
    readOnly = false
}: RadioButtonProps) {
    function handleSelect() {
        if (readOnly) {
            return;
        }

        onSelect();
    }

    return (
        <div className={`${containerClassName} text-nowrap`}>
            <input
                id={inputId}
                className={`form-check-input me-1 ${readOnly ? "read-only-check" : ""}`}
                type="radio"
                checked={checked}
                onChange={handleSelect}
                name={name}
            />
            <label
                htmlFor={inputId}
                className={`form-check-label ${labelClassName} ${readOnly ? "pe-none" : ""}`}
                onClick={onLabelClick}
            >
                {label}
            </label>
        </div>
    );
}

export default RadioButton;
